import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../../lib/i18n.jsx";
import { PRODUCTS } from "../../lib/products.js";
import TiltCard from "./animations/TiltCard.jsx";

export default function Products({ onSelectProduct, onRequestQuote }) {
  const { t, lang } = useI18n();

  return (
    <section
      id="productos"
      className="py-24 lg:py-32 bg-[#f7f7f4]"
      data-testid="products-section"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-16">
          <div className="max-w-2xl">
            <div className="eu-data-label mb-4">
              <i className="fa-solid fa-vials mr-2"></i>
              {t.products.eyebrow}
            </div>
            <h2 className="font-display text-4xl lg:text-5xl text-[#133322] leading-tight">
              {t.products.title}
            </h2>
            <p className="mt-4 text-[#5c6b61] text-base lg:text-lg max-w-xl">
              {t.products.subtitle}
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {PRODUCTS.map((p, idx) => (
            <TiltCard
              key={p.id}
              max={6}
              className={`eu-card relative overflow-hidden flex flex-col group hover:shadow-[0_30px_60px_rgba(19,51,34,0.12)] ${
                idx === 0 ? "lg:col-span-2" : ""
              }`}
              innerClassName="flex flex-col h-full"
              data-testid={`product-card-${p.id}`}
            >
              <div className="relative aspect-[4/3] eu-product-bg overflow-hidden">
                <img
                  src={p.image}
                  alt={p.name[lang]}
                  className="absolute inset-0 w-full h-full object-contain p-8 transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute top-4 left-4 eu-data-label bg-[#f7f7f4]/80 backdrop-blur px-3 py-1.5 rounded-full">
                  {p.category[lang]}
                </div>
                <div className="absolute top-4 right-4 font-mono-eu text-[10px] font-bold tracking-wider bg-[#133322] text-[#f7f7f4] px-3 py-1.5 rounded-full">
                  {p.npk}
                </div>
              </div>

              <div className="p-6 lg:p-8 flex-1 flex flex-col">
                <h3 className="font-display text-2xl lg:text-3xl text-[#133322] leading-tight">
                  {p.name[lang]}
                </h3>
                <p className="mt-3 text-sm text-[#5c6b61] flex-1">
                  {p.tagline[lang]}
                </p>

                <div className="mt-6 flex flex-wrap gap-3">
                  <button
                    onClick={() => onSelectProduct(p)}
                    className="eu-btn-primary text-sm py-2.5 px-5"
                    data-testid={`product-detail-${p.id}`}
                  >
                    {t.products.view_detail}
                    <i className="fa-solid fa-arrow-right text-[10px]"></i>
                  </button>
                  <button
                    onClick={() => onRequestQuote(p)}
                    className="eu-btn-outline text-sm py-2.5 px-5"
                    data-testid={`product-quote-${p.id}`}
                  >
                    {t.products.request_quote}
                  </button>
                </div>
              </div>
            </TiltCard>
          ))}
        </div>
      </div>
    </section>
  );
}
